import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
const currentUserApplicationConfigurationState = buildServiceState({
    allowEmptyRequest: true,
    key: 'currentUserApplicationConfiguration',
    requireLoggedIn: true,
    service: Core.GetApplicationConfiguration,
});
export default currentUserApplicationConfigurationState;
//# sourceMappingURL=current-user-application-configuration-state.js.map